import { Component, OnInit } from '@angular/core';
import { MasterService } from 'src/app/services/master/master.service';
import { ImportFilesDialogService } from 'src/app/_utils/import-files-dialog/import-files-dialog.service';
import {CommonMessages,ClientMessages} from 'src/app/shared/messages/messages.enum';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'app-gender',
  templateUrl: './gender.component.html',
  styleUrls: ['./gender.component.css']
})
export class GenderComponent extends BaseComponent implements OnInit {
  public genderObj: any = [];
  cp = 1;
  ord = true;
  colname: "Gender Name";
  text;
  checked = false;

  today: number = Date.now();
  constructor(private master: MasterService,
    private ImportFilesDialogService: ImportFilesDialogService
  )
  {
    super();
  }
  chgord(col) {
    this.ord = !this.ord
    this.colname = col
  }
  ngOnInit() {
    this.getGender();
  }
  getGender() {
    let self = this;
    this.ngxSpinnerService.show();
    this.master.getGender().subscribe(data => {
      self.genderObj = data;
    //  console.log(self.genderObj);
    //  console.log(data);
      this.ngxSpinnerService.hide();
    }, error => {
     // console.log(error);
      this.ngxSpinnerService.hide();
    });
  }
  editGender(id) {
    this.router.navigate(['/corporate/newgender'], { queryParams: { sexid: id } });
  }
  deleteGender(id) {
    let obj = {
      id: id
    }
    this.confirmationDialogService.confirm('PLEASE CONFIRM', 'Are you sure you want to Delete ?', 'Yes', 'No')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          this.master.delGender(obj).subscribe(data => {
            if (data.status) {
              this.getGender();
              setTimeout(() => {
                this.toastrService.success("Deleted Successfully");
              }, 1000)
            } else {
              this.toastrService.error(data.message);
            }
            this.ngxSpinnerService.hide();
          }, error => {
           // console.log(error);
            this.ngxSpinnerService.hide();
          });
        }
      })
      .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
  }

  updateGenderStatus(event, id) {
    let value = event.source.checked;
    let obj = this.genderObj.find(element => {
      if (element.sexid === id) {
        return true;
      }
    });
    obj = obj;
    obj.isactive = value;
    this.confirmationDialogService.confirm('PLEASE CONFIRM', CommonMessages.activeInactiveConfirmation +" '"+ (value? "Active": "Inactive") +"'", 'Ok', 'Cancel')
      .then((confirmed) => {
        if (confirmed) {
          this.ngxSpinnerService.show();
          let genderObj = {
            isactive: obj.isactive,
            sexid: id
          }
          this.master.updateGenderStatus(obj).subscribe(data => {
            if (data.status) {
              this.toastrService.success(CommonMessages.statusUpdated);
              this.ngxSpinnerService.hide();
            }
          }, error => {
            console.error(error);
            this.ngxSpinnerService.hide();
          });
        }
      }).catch(() => {
        event.source.checked = !event.source.checked;
       // console.log(CommonMessages.dialogDismissMessage)
      });
  }
  clickEvent() { }
  importFile() {
    let self = this;
    self.ImportFilesDialogService.confirm('Please Choose the File Path ', `../../../assets/margo-import-files/margo-theme-import.csv`, 'addingThemeBulk')
      .then(data => {
       // console.log(data);
        self.getGender();
      })
      .catch(err => {
        console.error(err);
       // console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      })
  }
  exportFile() {
    let tablename = {
      "tableName": "master_sex"
    }
    this.master.exportBulk(tablename).subscribe(dataFile => {
      if (dataFile.status) {
        let selBox = document.createElement('a');
        var att = document.createAttribute("href");
        att.value = dataFile.file;
        var att1 = document.createAttribute("download");
        selBox.setAttributeNode(att);
        selBox.setAttributeNode(att1);
        document.body.appendChild(selBox);
        selBox.click();
      }
    }, err => {
      this.toastrService.error(err.message);
    });
  }

  setValue(event) {
    let self = this;
    let url = event.target.src;
    if (url.indexOf("master_images") > 0) {
      url = url.substring(url.indexOf("master_images"), url.length)
      if (!this.isUrlValid(url)) {
        let awsUrl = self.master.getUrlfile(url);
        event.target.src = self.isUrlValid(awsUrl) ? awsUrl : '../../../assets/custom/images/broken.png';
      } else {
        event.target.src = '../../../assets/custom/images/broken.png';
      }
    } else {
      event.target.src = '../../../assets/custom/images/broken.png';
    }
    event.target.onerror = null;
  }

  isUrlValid(userInput) {
    return /(https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/i.test(userInput);
  }
}
